import { useQuery } from '@vue/apollo-composable'
import type { UseQueryReturn } from '@vue/apollo-composable'
import type {
  FavoriteQueryResult,
  FavoriteQueryVariables,
} from '@/fish/lib/highlight-favorites/types'
import { FavoritableTypes } from '@onxmaps/supergraph'
import { allFavoritedWaterbodies } from '@/fish/lib/highlight-favorites/queries'

/**
 * Fetch the list of all waterbodies a user has favorited
 */
export const getAllFavoritedWaterbodies = (
  after: string | null = null
): UseQueryReturn<FavoriteQueryResult, FavoriteQueryVariables> => {
  return useQuery<FavoriteQueryResult, FavoriteQueryVariables>(
    allFavoritedWaterbodies(),
    {
      filter: {
        entityTypes: [FavoritableTypes.Lake],
      },
      after,
    }
  )
}
